<app-loader [isLoading]="isLoading"></app-loader>
<div class="modal-heading">
    <div class="close-button invisible"></div>
    <div class="header-text">Filters</div>
    <div class="close-button" (click)="closeDialog()">
        <mat-icon class="close-icon">close</mat-icon>
    </div>
</div>
<div class="modal-body">
    <div class="filter-options">
        @for (item of filterOptions; track item.id; let i = $index) {
        <div [class]="
          i === selectedFilterIndex
            ? 'side-option-active'
            : 'side-option-inactive'
        " (click)="selectFilterItem(i)" (keydown.enter)="selectFilterItem(i)" tabindex="0">
            <div [class]="
            i === selectedFilterIndex
              ? 'side-option-title-active'
              : 'side-option-title-inactive'
          ">
                {{ item.title }}
            </div>
        </div>
        }
    </div>
    <div class="filter-values">
        @switch (selectedFilterIndex) {
        @case (FILTERS.fy) {
        <div style="display: flex; flex-direction: column; gap: 16px">
            <div class="custom-dropdown">
                <mat-form-field class="select-mat-form-field custom-select-form">
                    <mat-select class="custom-mat-select custom-select" placeholder="Select year"
                        [formControl]="selectedFY">
                        @for (fy of FY; track fy) {
                        <mat-option [value]="fy.key" (click)="onFYChange()">{{fy.value}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        }
        @case (FILTERS.addr) {
        <div style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            overflow-y: auto;
          ">
            <div style="display: flex; flex-direction: column; gap: 16px">
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select custom-select" placeholder="Select State"
                            [formControl]="seletedState" (selectionChange)="onStateChange($event.value)">
                            @for (state of States; track state) {
                            <mat-option [value]="state" 
                                >{{state}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select custom-select" placeholder="Select District"
                            [formControl]="selectedDist">
                            @for (dist of dropDownDist; track dist) {
                            <mat-option [value]="dist">{{dist}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        }
        }
    </div>
</div>
<div class="modal-footer">
    <button class="dp-secondary-btn" style="height: 4vh;" (click)="resetFilter()">
        Clear filters
    </button>
    <button class="dp-primary-btn" style="height: 4vh;" (click)="applyFilter()">
        Apply filters
    </button>
</div>